import { InjectionToken } from '@angular/core';

export interface UnifiedPatientsConfig {
	getBasePath(): string;
	getCompanyId(): number;
	getContactId(): number;
	getBffUrl(): string;
	getHostRxApiUrl(): string;
	getDateFormat(): string;
	getDobMask(): string;
	getEnvironment(): string;
	getRegion(): string;
	getSessionType(): string;
	getAppBISessionId(): string | null;
}

export const UNIFIED_PATIENTS_CONFIG = new InjectionToken<UnifiedPatientsConfig>('UNIFIED_PATIENTS_CONFIG', {
	providedIn: 'root',
	factory: () => ({
		getBasePath: () => '',
		getCompanyId: () => 0,
		getContactId: () => 0,
		getBffUrl: () => '',
		getHostRxApiUrl: () => '',
		getDateFormat: () => 'MM/DD/YYYY',
		getDobMask: () => '',
		getEnvironment: () => '',
		getRegion: () => '',
		getSessionType: () => '',
		getAppBISessionId: () => null
	})
});
